import React from 'react';

import { Button } from '@components/atoms';
import { device } from '@styles/mediaQuery';
import Rocket from '@public/icons/rocket.svg';
import styled, { css } from 'styled-components';
import { HOME } from '@shared/constants/navigate';

type ErrorLayoutProps = {
  title: string;
};

function ErrorLayout({ title }: ErrorLayoutProps) {
  const onClick = () => {
    window.location.href = HOME;
  };

  return (
    <Wrapper>
      <StyledTitle>{title}</StyledTitle>

      <Button
        height="45px"
        width="220px"
        title="GO TO HOMEPAGE"
        bgColor="textPrimary"
        color="white"
        Icon={Rocket}
        onClick={onClick}
      />
    </Wrapper>
  );
}

const StyledTitle = styled.span`
  margin-bottom: 45px;
  padding: 0 20px;
  text-align: center;

  color: ${({ theme }) => theme.colors.textPrimary};

  ${device.mobileL(css`
    font-size: 26px;
  `)}
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  height: calc(100vh - 254px);

  ${device.laptopS(css`
    height: calc(100vh - 178px);
  `)}
`;

export default ErrorLayout;
